/**
 * Convert a mongoDb objectId into a date object
 */
export const dateFromObjectId = (objectId: string): Date => {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};
